var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3186_77970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.837891H29.6532C30.9488 0.837891 31.9991 1.8882 31.9991 3.18383H8.5V0.837891Z",
    fill: "#4DD099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.18383C0 1.8882 1.05031 0.837891 2.34594 0.837891H2.40906V3.18383H0Z",
    fill: "#4DD099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28125 0.837891H6.62306V3.18383H4.28125V0.837891Z",
    fill: "#4DD099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89744 9.54102C5.25181 9.54102 4.72656 10.0663 4.72656 10.7119V12.6895C4.72656 13.3351 5.25181 13.8604 5.89744 13.8604C6.54306 13.8604 7.06831 13.3351 7.06831 12.6895V10.7119C7.06837 10.0663 6.54306 9.54102 5.89744 9.54102Z",
    fill: "#4DD099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.05859V21.3363C0 23.5454 1.79086 25.3363 4 25.3363H8.347C8.37269 21.1379 11.7956 17.7302 16 17.7302C20.2044 17.7302 23.6272 21.1378 23.6529 25.3363H28C30.2091 25.3363 32 23.5454 32 21.3363V5.05859H0ZM8.94481 12.6889C8.94481 14.3684 7.57844 15.7348 5.89894 15.7348C4.21944 15.7348 2.85306 14.3684 2.85306 12.6889V10.7113C2.85306 9.03178 4.21944 7.66541 5.89894 7.66541C7.57844 7.66541 8.94481 9.03178 8.94481 10.7113V12.6889ZM14.7218 15.6871H12.8468V9.68097H11.1307V7.80597H14.7218V15.6871ZM23.2294 12.6889C23.2294 14.3684 21.8631 15.7348 20.1836 15.7348C18.5041 15.7348 17.1377 14.3684 17.1377 12.6889V10.7113C17.1377 9.03178 18.5041 7.66541 20.1836 7.66541C21.8631 7.66541 23.2294 9.03178 23.2294 10.7113V12.6889ZM29.0065 15.6871H27.1315V9.68097H25.4856V7.80597H29.0065V15.6871Z",
    fill: "#4DD099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1826 9.54102C19.537 9.54102 19.0117 10.0663 19.0117 10.7119V12.6895C19.0117 13.3351 19.537 13.8604 20.1826 13.8604C20.8282 13.8604 21.3535 13.3351 21.3535 12.6895V10.7119C21.3535 10.0663 20.8282 9.54102 20.1826 9.54102Z",
    fill: "#4DD099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 19.6055C12.8111 19.6055 10.2188 22.1977 10.2188 25.3841C10.2188 28.5705 12.811 31.1627 15.9974 31.1627C19.1837 31.1627 21.7759 28.5705 21.7759 25.3841C21.7759 22.1977 19.1837 19.6055 15.9974 19.6055ZM14.8611 28.4152L12.3523 25.9064L13.6781 24.5806L14.8725 25.7749L18.3224 22.384L19.6367 23.7213L14.8611 28.4152Z",
    fill: "#4DD099"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3186_77970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBits);
export default __webpack_public_path__ + "static/media/icon_bits.5383015ddcf823b6359f361bfdfd9271.svg";
export { ForwardRef as ReactComponent };